var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"operator-main",on:{"click":_vm.handleClick}},[_c('i',{staticClass:"el-icon-plus"})])
}
var staticRenderFns = []

export { render, staticRenderFns }